module.exports = __webpack_public_path__ + "img/warlock.83ccacf1.jpg";